// Espejo frontend de CLIENTE_COLUMNS (API-PROAPP src/services/importExport/definitions/cliente.definition.ts).
// Solo se usa para renderizar labels en el preview de importación/exportación.
export const CLIENTE_COLUMNS = [
  { key: 'id', label: 'id', type: 'number' },
  { key: 'rut', label: 'rut', type: 'string', required: true },
  { key: 'name', label: 'name', type: 'string', required: true },
  { key: 'nAscensores', label: 'nAscensores', type: 'number' },
  { key: 'address', label: 'address', type: 'string' },
  { key: 'commune', label: 'commune', type: 'string' },
  { key: 'contactName', label: 'contactName', type: 'string' },
  { key: 'phone', label: 'phone', type: 'string' },
  { key: 'email', label: 'email', type: 'string' },
  { key: 'active', label: 'active', type: 'boolean' },
  { key: 'proxCert', label: 'proxCert', type: 'string' },
  { key: 'id_tipo_ascensor', label: 'id_tipo_ascensor', type: 'number' },
  { key: 'automatizadoManPreven', label: 'automatizadoManPreven', type: 'boolean' },
  { key: 'envio_auto_comprobante', label: 'envio_auto_comprobante', type: 'boolean' },
  { key: 'envio_auto_mantencion', label: 'envio_auto_mantencion', type: 'boolean' },
];
